<div class="tracker-container">
  <ng-container *ngFor="let stage of stages; let i = index; first as isFirst">
    <div *ngIf="!isFirst" class="tracker-in-between" [ngClass]="getClassForStatus(stage.status)"></div>
    <div class="tracker-stage">
      <div class="tracker-stage-icon" [ngClass]="getClassForStatus(stage.status)">
        <div *ngIf="stage.status === 'in_progress'" class="tracker-in-progress-icon">
          <span class="tracker-ellipsis-animation">.</span>
          <span class="tracker-ellipsis-animation">.</span>
          <span class="tracker-ellipsis-animation">.</span>
        </div>
        <mat-icon *ngIf="stage.status === 'completed'">done</mat-icon>
        <mat-icon *ngIf="stage.status === 'failed'">close</mat-icon>
      </div>
      <div class="description-stage">
        <span>{{ stage.name }}</span>
      </div>
    </div>
  </ng-container>
</div>
